import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function SprinklerIcon(props) {
	return (
		<IconBase type="sprinkler" {...props}>
			<path d="M16 4.5L18 3.5V2.5H6V3.5L8 4.5V5.5L8.5 11L10.5 12.75V11L9.5 10.25V5.5H14.5V10.25L13.5 11V12.75L15.5 11L16 5.5V4.5Z" />
			<path d="M10.5 6H13.5V6.5L14 7H12.5V11H13V13.5236C14.7252 13.6069 16 13.9005 16 14.25C16 14.6642 14.2091 15 12 15C9.79086 15 8 14.6642 8 14.25C8 13.9005 9.27477 13.6069 11 13.5236V11H11.5V7H9.99999L10.5 6.5V6Z" />
			<path d="M12.25 19.9968L12.5 21.9968H11.5L11.75 19.9968H12.25Z" />
			<path d="M12.5 18.9968L12.25 16.9968H11.75L11.5 18.9968H12.5Z" />
			<path d="M7.83199 18.9083L8.21881 19.2251L7.14498 20.9308L6.37134 20.2971L7.83199 18.9083Z" />
			<path d="M10.1197 16.9041L9.73287 16.5873L8.27222 17.9762L9.04586 18.6098L10.1197 16.9041Z" />
			<path d="M5.3692 17.0303L5.6192 17.4633L4.01215 18.6798L3.51215 17.8138L5.3692 17.0303Z" />
			<path d="M8.21722 15.9633L7.96722 15.5303L6.11017 16.3138L6.61017 17.1798L8.21722 15.9633Z" />
			<path d="M16.168 18.9083L15.7812 19.2251L16.855 20.9308L17.6287 20.2971L16.168 18.9083Z" />
			<path d="M13.8803 16.9041L14.2671 16.5873L15.7278 17.9762L14.9541 18.6098L13.8803 16.9041Z" />
			<path d="M18.6309 17.0303L18.3809 17.4633L19.9879 18.6798L20.4879 17.8138L18.6309 17.0303Z" />
			<path d="M15.7828 15.9633L16.0328 15.5303L17.8898 16.3138L17.3898 17.1798L15.7828 15.9633Z" />
		</IconBase>
	);
}
SprinklerIcon.propTypes = iconPropTypes;
